(() => {
  if (!customElements.get('sf-help-list'))
    customElements.define(
      'sf-help-list',
      class extends HTMLElement {
        connectedCallback() {
          this.controller = new AbortController();
          const opts = { signal: this.controller.signal };
          this.addEventListener(
            'input',
            (e) => {
              if (!e.target.matches('[data-help-filter]')) return;
              const q = e.target.value.toLocaleLowerCase().trim();
              let count = 0;
              this.querySelectorAll('[data-help-question]').forEach((item) => {
                item.hidden = !item.textContent.toLocaleLowerCase().includes(q);
                if (!item.hidden) count++;
              });
              const empty = this.querySelector('[data-help-empty]');
              if (empty) empty.hidden = count > 0;
            },
            opts,
          );
          this.addEventListener(
            'shopify:block:select',
            (e) => {
              const details = e.target.closest('details');
              if (details) details.open = true;
            },
            opts,
          );
        }
        disconnectedCallback() {
          this.controller?.abort();
        }
      },
    );
})();
